import React from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Box,
  Typography,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";
// import { setTemplateCategory } from "../../../../redux/Slice/Templates/templateSlice";
import { setSelectedCategory } from "../../../../redux/Slice/Templates/templateCreationSlice";

const FirstStepMainBody = () => {
  const dispatch = useDispatch();
  const selectedCategory = useSelector(
    (state) => state.templateCreation.selectedCategory
  );

  const handleCategoryChange = (event, newCategory) => {
    if (newCategory !== null) {
      dispatch(setSelectedCategory(newCategory));
    }
  };

  return (
    <Box>
      <Typography 
        variant="h6" 
        marginBottom={{ xs: 1, sm: 1.5, md: 2, lg: 2, xl: 2 }}
        sx={{
          fontSize: { xs: "16px", sm: "18px", md: "20px", lg: "24px", xl: "24px" },
        }}
      >
        Set up your template
      </Typography>
      <Typography 
        marginBottom={{ xs: 2, sm: 2.5, md: 3, lg: 3, xl: 3 }}
        sx={{
          fontSize: { xs: "11px", sm: "12px", md: "14px", lg: "14px", xl: "14px" },
        }}
      >
        Choose the category that best describes your message template. Then
        select the type of message you want to send.
      </Typography>

      {/* Category Selection */}
      <ToggleButtonGroup
        value={selectedCategory}
        exclusive
        onChange={handleCategoryChange}
        sx={{ 
          marginBottom: { xs: 2, sm: 2.5, md: 3, lg: 3, xl: 3 },
          "& .MuiToggleButton-root": {
            fontSize: { xs: "11px", sm: "12px", md: "14px", lg: "14px", xl: "14px" },
            padding: { xs: "8px 12px", sm: "10px 16px", md: "12px 20px", lg: "12px 20px", xl: "12px 20px" },
          },
        }}
        fullWidth
      >
        <ToggleButton value="Marketing">Marketing</ToggleButton>
        <ToggleButton value="Utility">Utility</ToggleButton>
        <ToggleButton value="Authentication">Authentication</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default FirstStepMainBody;
